import { useEffect, useState } from 'react';
import { parseFirebaseStoragePath, refreshFirebaseImageUrl, resolveImageUrl } from '../utils/imageUrl';

/**
 * Image with lazy loading + Firebase URL refresh on failure.
 */
function SafeImage({
  src,
  alt = '',
  className,
  style,
  loading = 'lazy',
  decoding = 'async',
  fallback = null,
  onError: onErrorProp,
}) {
  const [resolvedSrc, setResolvedSrc] = useState(() => resolveImageUrl(src));
  const [failed, setFailed] = useState(false);
  const [retried, setRetried] = useState(false);

  useEffect(() => {
    setResolvedSrc(resolveImageUrl(src));
    setFailed(false);
    setRetried(false);
  }, [src]);

  if (!resolvedSrc || failed) {
    return fallback;
  }

  const handleError = async (e) => {
    if (!retried && parseFirebaseStoragePath(resolvedSrc)) {
      setRetried(true);
      const fresh = await refreshFirebaseImageUrl(resolvedSrc);
      if (fresh && fresh !== resolvedSrc) {
        setResolvedSrc(fresh);
        return;
      }
    }
    setFailed(true);
    onErrorProp?.(e);
  };

  return (
    <img
      src={resolvedSrc}
      alt={alt}
      className={className}
      style={style}
      loading={loading}
      decoding={decoding}
      onError={handleError}
    />
  );
}

export default SafeImage;
